import { jsx as r, jsxs as l } from "react/jsx-runtime";
import { useId as h } from "react";
import { W as j } from "../index-PMSPXTub.js";
import { c as o } from "../clsx-OuTLNxxd.js";
import '../List.css';const m = "_list_1vjuq_1", q = "_listItem_1vjuq_10", v = "_listItemText_1vjuq_16", d = "_iconWrapper_1vjuq_20", z = "_check_1vjuq_28", i = {
  list: m,
  listItem: q,
  listItemText: v,
  iconWrapper: d,
  check: z,
  "size--s": "_size--s_1vjuq_32",
  "size--m": "_size--m_1vjuq_44"
}, W = { s: "xsm", m: "sm" }, $ = ({ classNames: t, direction: e, items: _, size: n = "m", ...p }) => {
  const c = h(), I = e ? { flexDirection: e } : {};
  return /* @__PURE__ */ r(
    "ul",
    {
      className: o(i.list, i[`size--${n}`], t == null ? void 0 : t.wrapper),
      "data-cxy-name": "list",
      style: I,
      ...p,
      children: _.map((x, u) => /* @__PURE__ */ l("li", { className: o(i.listItem, t == null ? void 0 : t.listItem), children: [
        /* @__PURE__ */ r("span", { className: o(i.iconWrapper, t == null ? void 0 : t.iconWrapper), children: /* @__PURE__ */ r(j, { className: o(i.check, t == null ? void 0 : t.checkIcon), color: "blue", size: W[n] }) }),
        /* @__PURE__ */ r("span", { className: o(i.listItemText, t == null ? void 0 : t.listItemText), children: x })
      ] }, `list-${c}-item-${u}`))
    }
  );
};
export {
  $ as List
};
